import { Address } from './address.model';
import { Contact } from './contact.model';
import { Phone } from './phone.model';

export class Facility {
    FacilityId?: number;
    PracticeGroup?: string;
    OfficeName?: string;
    Address?: Address;
    Phone?: Phone;
    Fax?: string;
    Email?: string;
    Rank?: number;
    Contacts?: Contact[];
    ContactAdded?: number;
    ServiceId?:number;
    DynamicForm?:any;
    FacilityContacts?: any[];
    Extension?: string;

}

